import React from "react"; 
import "./WhatsAppButton.css"; 
// Import styles 
const WhatsAppButton = () => { 
    const phoneNumber = "254717267162"; 
    // Replace with your WhatsApp number (without '+' or dashes) 
    const message = "Hello, I am interested in learning more about your insurance services. Can you provide more details?"; 
    // Default message 
    return ( 
    <a href={`https://wa.me/${phoneNumber}? 
    text=${encodeURIComponent(message)}`} 
    className="whatsapp-float" 
    target="blank" 
    rel="noopener noreferrer">
     <i className="fa-brands fa-whatsapp"></i>
    </a> 
    ); 
    
}; 
    
    export default WhatsAppButton;